export default __webpack_public_path__ + "static/media/2.2819f43f.jpg";